import { getElMerkleRoot } from "@services/index";
import { useQuery } from "@tanstack/react-query";

export function useElMerkleRoot() {
  return useQuery({
    queryKey: ["el-merkle-root"],
    queryFn: async () => {
      const res = await getElMerkleRoot();
      return res.data;
    },
  });
}
